"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseFilter = void 0;
class BaseFilter {
    constructor(id, name, type, defaultValue, model, explore, dimension) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.defaultValue = defaultValue;
        this.model = model;
        this.explore = explore;
        this.dimension = dimension;
        this.defaultValues = defaultValue?.split(',');
    }
    static get QUERY_FIELDS() {
        return 'id,name,type,default_value,model,explore,dimension';
    }
}
exports.BaseFilter = BaseFilter;
